import { auth } from '@/firebase';

const state = {
  user: JSON.parse(localStorage.getItem('user'))
};

const getters = {
  user: state => state.user
};

const mutationTypes = {
  SET_USER: 'SET_USER'
};

const actions = {
  async login(context, { email, password }) {
    await auth.signInWithEmailAndPassword(email, password);
    const user = auth.currentUser;
    localStorage.setItem('user', JSON.stringify(user));
    context.commit(mutationTypes.SET_USER, user);
  },
  async logout(context) {
    await auth.signOut();
    localStorage.removeItem('user');
    context.commit(mutationTypes.SET_USER, null);
  }
};

const mutations = {
  [mutationTypes.SET_USER](state, user) {
    state.user = user;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
